import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "./ui/card";

interface SubSectionCardProps {
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  footer?: React.ReactNode;
  children?: React.ReactNode;
}

export function SubSectionCard({
  title,
  description,
  footer,
  children
}: SubSectionCardProps) {
  return (
    <Card className="@container/card">
      <CardHeader className="relative">
        <CardTitle className="@[250px]/card:text-3xl text-2xl font-semibold tabular-nums">
          {title}
        </CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent>{children}</CardContent>
      {footer && (
        <CardFooter className="flex-col items-start gap-1 text-md">
          {footer}
        </CardFooter>
      )}
    </Card>
  );
}
